<template>
  <div class="main">
    <GoBack :name="`账户设置`" :type="2" :path="`/mobile/my`"></GoBack>
    <div class="account-content">
      <div class="account-item">
        <div class="left">手机号</div>
        <div class="right">
          {{ userInfo.mobile }}
          <img src="@/assets/mobile/image/my/arrow.png" />
        </div>
      </div>

      <div class="account-item">
        <div class="left">修改密码</div>
        <div class="right" @click="gourl('/mobile/updateSettings?type=1')">
          <span>修改</span>
          <img src="@/assets/mobile/image/my/arrow.png" />
        </div>
      </div>

      <div class="account-item">
        <div class="left">支付宝账号</div>
        <div class="right" @click="gourl('/mobile/updateSettings?type=2')">
          <span v-if="alipay">{{ alipayName }} {{ alipay | phoneFrom }}</span>
          <span v-else>未绑定</span>
          <img src="@/assets/mobile/image/my/arrow.png" />
        </div>
      </div>
    </div>

    <!-- 退出登录按钮 -->
    <div class="logout-box">
      <button class="logout-btn" @click="handleLogout">退出登录</button>
    </div>
  </div>
</template>
<script>
import GoBack from "@/components/goBack";
import { getAlipay, getAccount } from "@/api/mobile";
export default {
  filters: {
    phoneFrom(phone) {
      return phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
    },
  },
  data() {
    return {
      userInfo: {},
      alipay: null,
      alipayName: null,
    };
  },
  components: { GoBack },
  methods: {
    gourl(path) {
      this.$router.push(path);
    },
    // 退出登录
    handleLogout() {
      this.$dialog.confirm({
        message: "确认退出登录？",
      })
        .then(() => {
          // 清除缓存
          localStorage.removeItem("token");
          localStorage.removeItem("userInfo");
          // 回到首页
          this.$router.push("/mobile/login");
          this.$toast.success("已退出登录");
        })
        .catch(() => {
          // 取消退出
        });
    },
    //获取支付宝信息
    async getAlipay() {
      await getAlipay().then((res) => {
        if (res.code === 200) {
          this.alipay = res.data.alipay;
          this.alipayName = res.data.name;
        }
      });
    },
  },
  async created() {
    if (localStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.$store.commit("changeUserInfo", this.userInfo);
    } else {
      await getAccount().then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.$store.commit("changeUserInfo", this.userInfo);
          localStorage.setItem("userInfo", JSON.stringify(res.data));
        }
      });
    }
    await this.getAlipay();
  },
};
</script>
<style lang="scss" scoped>
.main {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #f8f8f8;
  .account-content {
    position: absolute;
    width: 100%;
    background-color: #fff;
    top: 0;
    z-index: 0;
    padding: 50px 15px 30px 15px;
    box-sizing: border-box;
    .account-item {
      height: 52px;
      border-bottom: 1px solid #f4f4f4;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        color: #232323;
        font-size: 14px;
      }
      .right {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #232323;
        img {
          width: 14px;
          height: 14px;
          margin-left: 8px;
        }
        span {
          color: #808080;
        }
      }
    }
  }

  // 退出登录按钮样式
  .logout-box {
    position: absolute;
    bottom: 30px;
    left: 0;
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;

    .logout-btn {
      width: 100%;
      height: 48px;
      background: #ffffff;
      border: 1px solid #ff4d4f;
      border-radius: 24px;
      color: #ff4d4f;
      font-size: 16px;
      cursor: pointer;
      transition: all 0.3s;

      &:active {
        background: #fff1f0;
        opacity: 0.8;
      }
    }
  }
}
</style>